import { render, staticRenderFns } from "./OutbrineDashboard.vue?vue&type=template&id=5ddccfda&scoped=true"
import script from "./OutbrineDashboard.vue?vue&type=script&lang=js"
export * from "./OutbrineDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddccfda",
  null
  
)

export default component.exports